import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=38eea16a&scoped=true"
import script from "./CommentsList.vue?vue&type=script&lang=js"
export * from "./CommentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eea16a",
  null
  
)

export default component.exports